import { getChooseAreaDropDownData } from 'selectors/getChooseAreaDropDownData';

export const selectors = {
  getChooseAreaDropDownData,
};
